import { useGenerateFormElements } from "@/common/hooks";
import {
  FormFieldsStrategyType,
  Quote,
  QuoteLineType,
  QuotesType,
} from "@/common/types";
import { Form, Tag } from "antd";
import { useEffect, useState } from "react";
import CustomerActions from "../QuoteActions/CustomerActions";
import customerQuoteLineStrategy from "@/common/strategies/quoteLines/customer/customerQuoteLine.strategy";
import { usePermissions } from "@/common/contexts/Permissions.context";
import quotesRender from "@/common/const/elementsList/quotesRender.const";
import CustomTypography from "@/components/Typography/CustomTypography";
import CustomerQuoteLineStatusInfo from "./CustomerQuoteLineStatusInfo";

export default function CustomerQuoteLineForm({
  productType,
  productData,
  quoteData,
}: {
  productType: QuotesType | undefined;
  productData: QuoteLineType;
  quoteData: Quote;
}) {
  const [strategy, setStrategy] = useState<FormFieldsStrategyType[]>([]);
  const [form] = Form.useForm();
  const { formElements } = useGenerateFormElements(strategy);
  const { company } = usePermissions();
  const {isHavePermission} = usePermissions()
  useEffect(() => {
    if (!productData.price) return;
    setStrategy(() =>
      customerQuoteLineStrategy[productType as QuotesType].map((el) => ({
        ...el,
        readonly: true,
      }))
    );
    const formDefaultValue = Object.entries(productData.price).reduce(
      (acc, [key, value]) => {
        if (key === "targetOTC" || key === "targetMRC") {
          return {
            ...acc,
            [key]:
              value === null
                ? "0"
                : Number.parseFloat(value as string)
                    .toFixed()
                    .toString(),
          };
        }
        return {
          ...acc,
          [key]: value === null ? "" : value && value.toString(),
        };
      }
    );
    form.setFieldsValue({
      ...formDefaultValue,
      description: productData?.customerDescription || "",
      quoteType: productData?.quoteType,
    });
  }, [productData]);

  const pricing = [...formElements.slice(0, 4)];
  const productDataElements =
    company?.companyType === "airx"
      ? [...formElements.slice(4, -1)]
      : [...formElements.slice(4, -2)];

  return (
    <>
      <Form form={form} disabled={!isHavePermission('quotes_customer_edit')}>
        <div className="">
          <div className="bg-white rounded-lg p-5">
            <div className="flex justify-between">
              <div className="flex gap-2 items-center ">
                <CustomTypography>
                  {quotesRender.find((el) => el.value === productType)?.label}
                </CustomTypography>
                <Tag className="text-primary font-kanit text-[13px] leading-[13px] flex items-center justify-center border-none bg-primaryDim py-2">
                  Pricing
                </Tag>
              </div>
              <div>
                <CustomerQuoteLineStatusInfo
                  noBidReason={productData.noBidReason}
                  status={quoteData.status}
                />
              </div>
            </div>
            <div className="grid grid-cols-4 gap-4">{...pricing}</div>
          </div>
          <div className=" bg-white p-5 mt-5 rounded-lg">
            <div className="grid grid-cols-4 gap-4">
              {...productDataElements}
            </div>
            <div className="mt-1">{formElements[formElements.length - 1]}</div>
          </div>
        </div>

        <div className="flex gap-5 items-center mt-5">
          <CustomerActions
            quoteId={quoteData.id || productData.quoteId}
            noBidReason={productData.noBidReason}
            status={quoteData.status}
            quoteType={productData?.quoteType}
          />
        </div>
      </Form>
    </>
  );
}
